require('../../../assets/lib/angular/angular-ui.js');
require('../../../assets/scripts/common/jv.TemplateLoader.js');
require('../../../assets/scripts/common/polyfills.js');
require('../../../assets/scripts/common/directives/jv.FormTemplate.js');
require('../../../assets/scripts/common/angajaxservice.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/directives/jv.MessageTemplate.js');
require('../../../assets/scripts/common/directives/jv.AjaxSelect.js');
require('../../../assets/lib/js/angularmodule/angservice.js');
require('../../../assets/scripts/source/person/JV.NewPerson.js');
require('../../../assets/scripts/source/jobvites/JV.ShareJobviteUtil.js');
require('../../../assets/lib/jquery/jquery-ui-1.13.2.min.js');
require('../../../assets/lib/js/JV.FriendWidget_js_upgrade.webpack.js');
require('../../../assets/scripts/source/person/JV.ContactDetails.js');
require('../../../assets/lib/js/JV.json2.js');
require('../../../assets/scripts/source/widgets/JV.socialWidgets.js');
require('../../../assets/lib/js/fileuploader.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/jv.Loading.js');
require('../../../assets/scripts/common/jv.ScrollIntoView.js');
require('../../../assets/lib/select2/select2-3.4.5/select2.min.js');
require('../../../assets/lib/js/angularmodule/JV.Core.Directives.js');
require('../../../assets/scripts/common/jv.TextUtil.js');
require('../../../assets/scripts/common/jv.EmployeeSelect.js');
require('../../../assets/scripts/common/jv.Filters.js');
require('../../../assets/scripts/source/contacts/JV.ContactDetailsModal.Ctrl.js');
require('../../../assets/scripts/source/contacts/JV.ContactDetails.Ctrl.js');
require('../../../assets/scripts/source/contacts/jv.contacts.addToReq.controller.js');
require('../../../assets/scripts/source/contacts/JV.ContactDetails.svc.js');
require('../../../assets/scripts/common/directives/jv.Datepicker.js');
require('../../../assets/scripts/source/contacts/JV.ContactConstants.js');
require('../../../assets/scripts/source/contacts/JV.ContactService.js');
require('../../../assets/scripts/source/campaigns/V2/jv.campaigns.email-campaign-modal.directive.js');
require('../../../assets/scripts/source/contacts/JV.ContactDetails.App.js');
require('../../../assets/scripts/common/jv.Jobvite.Urls.js');
require('../../../assets/lib/onboarding/mask/jquery.mask-1.14.16.js');
require('../../../assets/scripts/source/person/jv.NumberFormat.js');
require('../../../assets/scripts/common/jv.NumberFormat.mask.directive.js');
require('../../../assets/scripts/common/directives/jv.Common.Currency.Directive.js');
require('../../../assets/scripts/common/directives/consentData/jv.Common.DataConsent.directive.js');